export default __webpack_public_path__ + "static/media/moon_logo_alien.e0cd6039.png";